/* The Mat Group - quantity band reconciler + minimum order guard.
   Products such as the counter ad mats and mouse mats price by quantity using one variant per
   "Quantity band" (100-249, 250-499, 500-999, 1000-2499, 2500-4999, 5000+).
   1) If a cart line's quantity is outside the band of its variant (quantity edited in the cart or
      drawer, or a hand-built add URL), the line is moved to the sibling variant whose band
      contains the quantity.
   2) The lowest band start is the minimum order. A line below it is raised to the minimum.
   3) Pressing a Checkout button re-checks the cart first (fails open after 4.5 seconds).
   Products without a band in the variant title are never touched. */
(function(){
  if (window.__tmgBandsInit) return;
  window.__tmgBandsInit = true;

  var BAND_RE = /^\s*(\d[\d,]*)\s*(?:-\s*(\d[\d,]*)|\+)\s*$/;
  var CART_URL = /\/cart(\.js|\/(add|change|update|clear)(\.js)?)?(\?|$)/;
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  if (!nativeFetch) return;
  var pcache = {}, busy = false, tried = {}, moving = {}, timer = null, bypass = false, pageDirty = false;
  function onCart(){ return location.pathname === '/cart' || location.pathname === '/cart/'; }
  function reloadOnce(){
    try { var t = parseInt(sessionStorage.getItem('tmgBandsRl') || '0', 10); if (Date.now() - t < 4000) return; sessionStorage.setItem('tmgBandsRl', String(Date.now())); } catch (e) {}
    pageDirty = false; location.reload();
  }

  var DBG = /[?&]tmgdebug/.test(location.search);
  function log(){ if (DBG) { try { console.log.apply(console, ['[tmg-bands]'].concat([].slice.call(arguments))); } catch (e) {} } }
  function num(s){ return parseInt(String(s).replace(/,/g, ''), 10); }
  function parseBand(title){
    if (!title) return null;
    var parts = String(title).split(' / ');
    var last = parts[parts.length - 1];
    var m = BAND_RE.exec(last);
    if (!m) return null;
    return { lo: num(m[1]), hi: m[2] ? num(m[2]) : Infinity };
  }
  function getProduct(handle){
    if (!pcache[handle]) {
      pcache[handle] = nativeFetch('/products/' + handle + '.js', { credentials: 'same-origin' }).then(function(r){ return r.json(); });
    }
    return pcache[handle];
  }
  function bandIndex(product){
    var o = product.options || [];
    for (var i = 0; i < o.length; i++) {
      var nm = (o[i] && o[i].name) ? o[i].name : o[i];
      if (/quantity band/i.test(String(nm))) return i;
    }
    return -1;
  }
  function minOrder(product){
    var bi = bandIndex(product), min = Infinity;
    if (bi < 0) return 0;
    product.variants.forEach(function(v){
      var opts = v.options || [v.option1, v.option2, v.option3];
      var b = parseBand(opts[bi]);
      if (b && b.lo < min) min = b.lo;
    });
    return isFinite(min) ? min : 0;
  }
  function targetVariant(product, item, qty){
    var bi = bandIndex(product);
    if (bi < 0) return null;
    var ov = item.options_with_values || [];
    for (var k = 0; k < product.variants.length; k++) {
      var v = product.variants[k];
      var opts = v.options || [v.option1, v.option2, v.option3];
      var ok = true;
      for (var i = 0; i < opts.length; i++) {
        if (i === bi) continue;
        if (ov[i] && opts[i] !== ov[i].value) { ok = false; break; }
      }
      if (!ok) continue;
      var b = parseBand(opts[bi]);
      if (b && qty >= b.lo && qty <= b.hi) return v;
    }
    return null;
  }
  /* A line is a misfit when its quantity is outside the band in its own variant title. The lowest
     band starts at the minimum order, so a below-minimum line is always a misfit. */
  function misfits(cart){
    var out = [];
    ((cart && cart.items) || []).forEach(function(it){
      var b = parseBand(it.variant_title);
      if (!b) return;
      if (it.quantity < b.lo || it.quantity > b.hi) out.push(it);
    });
    return out;
  }
  function post(url, body){
    log('POST', url, JSON.stringify(body));
    return nativeFetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(r){ return r.ok; }).catch(function(){ return false; });
  }
  function refreshUi(){
    if (location.pathname.replace(/\/+$/, '') === '/cart') { location.reload(); return; }
    try { if (window.CartDrawer && window.CartDrawer.refresh) window.CartDrawer.refresh(); } catch (e) {}
  }
  function hasProps(p){ if (!p) return false; for (var k in p) { if (Object.prototype.hasOwnProperty.call(p, k)) return true; } return false; }
  /* Moves a line to another band variant. The old line is removed FIRST and the new one is only added
     if that removal succeeded, so two overlapping runs cannot both add: the second removal fails. */
  function moveLine(it, v, want){
    return post('/cart/change.js', { id: it.key, quantity: 0 }).then(function(ok){
      if (!ok) return false;
      var line = { id: v.id, quantity: want };
      if (hasProps(it.properties)) line.properties = it.properties;
      return post('/cart/add.js', { items: [line] }).then(function(ok2){
        if (ok2) return true;
        var back = { id: it.variant_id, quantity: it.quantity };
        if (hasProps(it.properties)) back.properties = it.properties;
        return post('/cart/add.js', { items: [back] }).then(function(){ return false; });
      });
    });
  }
  /* At most 3 attempts per line and quantity in any 8 second window, so a line Shopify refuses to
     change can never loop. A line that is being moved to another band variant is locked for up to
     20 seconds, so a second trigger (for example the drawer's own minimum guard raising the same
     line while it is being moved) cannot repeat the move. */
  function allow(k){
    var r = tried[k], now = Date.now();
    if (!r || (now - r.t) > 8000) { r = tried[k] = { n: 0, t: now }; }
    if (r.n >= 3) return false;
    r.n++;
    return true;
  }
  function locked(it){ log('locked?', it.key, !!moving[it.key]); var t = moving[it.key]; return !!t && (Date.now() - t) < 20000; }
  /* Repairs every misfit line. Resolves true when something was changed. */
  function repair(cart, force){
    var list = misfits(cart).filter(function(it){ return !locked(it) && (force || allow(it.key + ':' + it.quantity)); });
    if (!list.length) return Promise.resolve(false);
    var chain = Promise.resolve(false);
    list.forEach(function(it){
      chain = chain.then(function(changed){
        return getProduct(it.handle).then(function(p){
          var min = minOrder(p);
          var want = Math.max(it.quantity, min);
          var v = targetVariant(p, it, want);
          if (!v) return changed;
          if (v.id === it.variant_id) {
            return post('/cart/change.js', { id: it.key, quantity: want }).then(function(ok){ return ok || changed; });
          }
          moving[it.key] = Date.now();
          return moveLine(it, v, want).then(function(ok){ return ok || changed; });
        }).catch(function(){ return changed; });
      });
    });
    return chain;
  }
  function fix(cart){
    log('fix called busy=' + busy, 'misfits=' + misfits(cart).map(function(i){ return i.variant_title + ' x' + i.quantity; }).join(';'));
    if (busy || !misfits(cart).length) return;
    busy = true;
    repair(cart, false).then(function(changed){ busy = false; if (changed) refreshUi(); }, function(){ busy = false; });
  }
  function check(){
    if (busy) return;
    nativeFetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); }).then(function(c){ fix(c); if (pageDirty && onCart() && !busy && !misfits(c).length) reloadOnce(); }).catch(function(){});
  }
  function schedule(){ clearTimeout(timer); timer = setTimeout(check, 450); }

  /* Cart changes made with fetch. Responses to plain cart reads are inspected directly. */
  window.fetch = function(input, init){
    var url = (typeof input === 'string') ? input : ((input && input.url) || '');
    var p = nativeFetch(input, init);
    if (CART_URL.test(url) && !busy) {
      p.then(function(res){
        try {
          if (/\/cart\.js(\?|$)/.test(url) && (!init || !init.method || String(init.method).toUpperCase() === 'GET')) {
            res.clone().json().then(fix).catch(function(){});
          } else { if (onCart()) pageDirty = true; schedule(); }
        } catch (e) {}
      }).catch(function(){});
    }
    return p;
  };
  /* Cart changes made with XMLHttpRequest. */
  try {
    var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(m, u){ this.__tmgUrl = String(u || ''); return xo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function(){
      if (CART_URL.test(this.__tmgUrl || '') && !/\/cart\.js/.test(this.__tmgUrl || '')) { this.addEventListener('loadend', function(){ if (onCart()) pageDirty = true; schedule(); }); }
      return xs.apply(this, arguments);
    };
  } catch (e3) {}

  /* Cart page: quantity boxes, then an initial check on load. */
  document.addEventListener('change', function(e){
    var t = e.target;
    if (t && t.matches && t.matches('input[name^="updates"], input[data-quantity-input], .cart-item input[type="number"], .cart-item input[type="text"]')) schedule();
  }, true);
  if (location.pathname.replace(/\/+$/, '') === '/cart') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
  }

  /* Checkout buttons: re-check the cart first, repair if needed, then let the click through.
     Fails open: if the check errors or takes longer than 4.5 seconds the click goes ahead. */
  function settle(n){
    return nativeFetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){
        if (!misfits(c).length) return true;
        if (n >= 5) return false;
        return repair(c, true).then(function(){ return new Promise(function(r){ setTimeout(r, 600); }); }).then(function(){ return settle(n + 1); });
      });
  }
  /* Band-aware quantity change used by the cart drawer (stepper and typed quantity). Quantity Limit
     refuses a change that leaves a line below its own band's minimum, so a line that crosses a band
     is moved straight to the right band variant instead (remove first, add second). Resolves
     { ok, qty } where qty is the quantity actually applied (raised to the minimum order if lower). */
  window.TMGBands = window.TMGBands || {};
  window.TMGBands.setQty = function(item, qty){
    qty = parseInt(qty, 10);
    if (!item || !item.key || !(qty >= 0)) return Promise.resolve({ ok: false, qty: item ? item.quantity : 0 });
    if (qty === 0) return post('/cart/change.js', { id: item.key, quantity: 0 }).then(function(ok){ return { ok: ok, qty: 0 }; });
    return getProduct(item.handle).then(function(p){
      var min = minOrder(p);
      var want = Math.max(qty, min);
      var v = targetVariant(p, item, want);
      if (!v || v.id === item.variant_id) {
        return post('/cart/change.js', { id: item.key, quantity: want }).then(function(ok){ return { ok: ok, qty: want }; });
      }
      moving[item.key] = Date.now();
      return moveLine(item, v, want).then(function(ok){ return { ok: ok, qty: want }; });
    }).catch(function(){ return { ok: false, qty: item.quantity }; });
  };

  var CHECKOUT_SEL = 'a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [data-cart-checkout], [data-checkout-button]';
  document.addEventListener('click', function(e){
    if (bypass || !e.target || !e.target.closest) return;
    var el = e.target.closest(CHECKOUT_SEL);
    if (!el) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var released = false;
    function release(){
      if (released) return;
      released = true;
      bypass = true;
      try { el.click(); } catch (x) {}
      setTimeout(function(){ bypass = false; }, 50);
    }
    var guard = settle(0).catch(function(){});
    var cap = new Promise(function(res){ setTimeout(res, 4500); });
    Promise.race([guard, cap]).then(release, release);
  }, true);
})();
